<template>
  <div style="height: 100%" :style="{
    ...setStyles,
  }">
    <t-loading class="loads" :loading="loading" style="height: 100%;">
      <!-- v-show="!loading" -->
      <div :id="props.current.id + 'map'" :class="{ 'container': true, 'hideCanvas': !loading }" :style="{
        height: props.current.cptHeight + 'px',
        width: props.current.cptWidth + 'px',
      }"></div>
      <template v-if="isChangePonitShow">
        <button class="isChangePonit" @click="clickisChangePonit">切换{{isChangePonit ? '圆点' : '标点'}}显示</button>
      </template>
      <template v-if="option.attribute.polyLine && option.attribute.polyLineAuto == 'shoudong'">
        <button id="lushu-shoudong" v-show="lushu" @click.stop>{{ lushuIsPlay ? '播放轨迹' : '暂停轨迹' }}</button>
        <button id="polyline-shoudong" v-show="!lushu" @click.stop>{{ !isPauseAnmination ? '暂停轨迹' : '播放轨迹'
          }}</button>
        <div class="polytype">
          <t-radio-group v-model="polyType" size="small" @change="changePolyType">
            <t-radio-button value="1">轨迹</t-radio-button>
            <t-radio-button value="2">路线</t-radio-button>
          </t-radio-group>
        </div>
      </template>
    </t-loading>
    <div class="action-loading" v-if="actionLoading">
      <t-loading :loading="true"></t-loading>
      <span>路线规划中</span>
    </div>
  </div>
</template>

<script setup>
import { getResByDatasetIdApi } from "@/api/dataset/dataset";
import { getDistance } from 'geolib'
import {
  getDataJson,
  pollingRefresh,
  getDefaultValue,
  hasNonEmptyValues,
  hasProperty,
} from "@/utils/refresh-cpt-data";
import { fileUrl } from "/env";
import {
  reactive,
  ref,
  getCurrentInstance,
  watch,
  onMounted,
  computed,
  defineEmits,
  inject,
} from "vue";
import { useRoute } from "vue-router";
import { nextTick } from "bin-editor-next";
// import cptRealtimeposition from "@/views/baidu/RealtimePosition";
// import loadBMap from '@/utils/baiduMap.js' //单个文件加载百度地图
const route = useRoute();
const currentRoute = route.name;
const instance = getCurrentInstance();
const _this = instance.proxy;

const container = ref(null);
let map = ref(null);
let marker = ref(null);
const label = ref(null);
let stateM = { arrMarker: [] };
let zoomCtrl = new BMapGL.ZoomControl(); // 添加缩放控件
let loading = ref(true);
let markersObj = {};
let polylineStart = ref(false)
let lushu = ref(false)
let actionLoading = ref(false)
let polyType = ref('1')
const props = defineProps({
  option: Object,
  current: Object,
});
let currentLevel = ref(null);
let currentPid = ref(null);
let resSonData = ref([]);

let isChangePonit = ref(false)

let copyNewData = [];

let infoWindows = []; // 信息窗口列表

let isPauseAnmination = ref(true)
let pauseStepIndex = ref(0)

let isPageReload = ref(true)

// 新增属性兼容旧代码
const attr = props.option.attribute;
if (!attr.globalDataReload) attr.globalDataReload = [0];
if (!attr.zoomCtrlShow) attr.zoomCtrlShow = false;
// if (!attr.isQueryDetail) attr.isQueryDetail = true

let dataReload = computed(() => props.option.attribute.globalDataReload || [0]);
watch(
  () => props.current.cptShow,
  (val) => {
    console.log("watch-cptShow-", val);
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  }
);
watch(
  () => props.option.attribute.hideCompInTab,
  (val) => {
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  }
);
watch(
  () => props.option.attribute.zoomCtrlShow,
  (val) => {
    if (val) {
      map.value.addControl(zoomCtrl);
    } else {
      map.value.removeControl(zoomCtrl);
    }
  }
);
watch(
  () => props.option.attribute.showname,
  (val) => {
    if (props.option.attribute.mapDrillDown) {
      initMapForDrillDown()
    } else {
      console.log('watch initMap int')
      initMap();
    }
  }
);


const isChangePonitShow = computed(() => {
  // return location.href.includes('30f77dcff63b64310436927ae97782a5')
    let dp_id = [
                  '30f77dcff63b64310436927ae97782a5',
                  '4caac5ae238d8345ac7336fd26988f7a',
                  'b300eb28b3a81207b1fb7c915c173742',
                  'e966344c175348ca44198b8bf93b0117',
                  'd3b1faac8392e6386b288df0410fbdef',
                  '1d721421b54679759f3c89021b452ea6',
                  'edb461ef0cd571afedba8c0871a8541b'
                ]
    let isShow = dp_id.some(id => location.href.includes(id))
    console.log(location.href,isShow,'qwijdqwjiqwdjiqjiwd' )
    return isShow
  
})

const lushuIsPlay = computed(() => {
  let isPlay = lushu.value?._intervalFlag
  let isPause = lushu.value?._fromPause
  let isStop = lushu.value?._fromStop
  return !isPlay || isPause || isStop
})

const setStyles = computed(() => {
  const loadBg = props.option.attribute.loadBg;
  const width = props.current.cptWidth - 2;
  return {
    "---loadBg": loadBg,
    "---loadBorder": "1px solid " + loadBg,
    "---width": width + "px",
    "position": "relative"
  };
});

const emit = defineEmits(["clickHandler"]);
const showContextMenu = inject("showContextMenu");

const hideLabel = (type) => {
  stateM.arrMarker.forEach((item) => {
    item.getLabel().setStyle({ display: type ? "block" : "none" });
  });
};

// const  moveToFront = (arr, predicate,targetIndex) => {
//   const index = arr.findIndex(predicate);
//   if (index !== -1) {
//     const element = arr.splice(index, 1)[0];
//     arr.splice(targetIndex, 0, element);
//   }
//   return arr;
// }
/**
 * 创建百度地图自定义覆盖物
 * @param tag  Dom元素
 * @param height  Dom元素高度
 * @param width  Dom元素宽度
 * @param url  图片元素地址
 * @param draggable  是否可拖拽
 * @param point  覆盖物定位
 * @param opacity  覆盖物透明度
 * @param map  地图实例对象
 * @param offsetY  偏移量
 * @param zIndex  覆盖物层级
 * @param properties  标题设置{}
 * @param enableMassClear  是否能被统一清除掉覆盖物
 */

const createCustomOverlay = ({
  tag = "img",
  height,
  width,
  url,
  draggable,
  point,
  opacity = 0.5,
  map,
  offsetY = 0,
  zIndex = 0,
  properties,
  enableMassClear = true
}) => {
  const createDOM = () => {
    const img = document.createElement(tag);
    img.style.height = height;
    img.style.width = width;
    img.src = url;
    img.draggable = draggable;
    return url ? img : document.createElement('div');
  };
  console.log(createDOM, 'createDOMcreateDOMcreateDOMcreateDOM');
  // 创建自定义覆盖物
  const customOverlayObj = new BMapGL.CustomOverlay(createDOM, {
    point,
    opacity,
    map,
    offsetY,
    zIndex,
    enableMassClear,
    properties: properties || {
      title: "",
      size: "100",
    },
  });
  return customOverlayObj;
};

const initMap = () => {

  console.log(cptData.value, '执行他initMapo');
  if (cptData.value.length == 0) {
    actionLoading.value = false
    loading.value = false
    // map.value.clearOverlays();
    console.log(map.value, 'asdjiasidjiasdjiasdijosdaijsodaijsdo');
    // return;
  }
  // map.value.clearOverlays();

  // 初始化清除标记点
  if(map.value) {
    map.value._customOverlays.map(item => {
      map.value.removeOverlay(item)
    })

  }
  


  let zoom = props.option.attribute.zoom;

  let centerxs = "";
  if (props.option.attribute.lightField) {
    console.log(cptData.value, props.option.attribute.lightField, 'cptData.valuecptData.valuecptData.valuecptData.value');
    let xpoint = cptData.value.find(
      (x) => {
        console.log(x.myObj[props.option.attribute.lightField], _this, _this?.paras?.value, 'qwdijqwi9udwqiu9dwqdu9ihqwd9uiwqduh9w');
        return x.myObj[props.option.attribute.lightField] == _this?.paras?.value || ''
      }
    );
    // xpoint.isLight = true;
    // xpoint.isLight = false;
    console.log(xpoint, 'xpointxpointxpoint');
    if (xpoint) {
      xpoint.isLight = true;
      centerxs = xpoint;
    } else {
      // 当地图没有数据 给默认坐标
      centerxs = cptData.value.length == 0 ? {
        "lng": "116.399",
        "lat": "39.910",
        "url": "",
        "name": ""
      } : cptData.value[0]
    }

  } else {
    // 当地图没有数据 给默认坐标
    centerxs = cptData.value.length == 0 ? {
      "lng": "116.399",
      "lat": "39.910",
      "url": "",
      "name": ""
    } : cptData.value[0]
  }
  map.value.centerAndZoom(new BMapGL.Point(centerxs.lng, centerxs.lat), zoom); // 初始化地图,设置中心点坐标和地图级别


  map.value.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放

  map.value.addEventListener("tilesloaded", () => {
    // 这里边写加载完成之后的执行操作
    console.log("loadingloading");
    loading.value = false;

  });
  map.value.addEventListener("rightclick", (e) => {
    // 这里边写加载完成之后的执行操作
    e.clientY = e.clientPos.y;
    e.clientX = e.clientPos.x;
  });

  map.value.clearOverlays();
  stateM.arrMarker = [];
  infoWindows = [];

  console.log('地图数据：', cptData.value);
  //渲染多个点及多个点对应的图标
  cptData.value.forEach((item, index) => {

    const infoHoverPopup = initHoverPopup(item)

    const {
      labelBgColor,
      labelBorderColor,
      labelOffsetX,
      labelOffsetY,
      textColor,
      textSize,
    } = props.option.attribute;

    if (props.option.cptDataForm.dataSource == "1") {
      let point = new BMapGL.Point(item.lng, item.lat);
      let zIndex = item.isLight ? 200 : 100;
      // 创建自定义覆盖物DOM
      const customOverlay = createCustomOverlay({
        tag: "img",
        height: item.isLight
          ? props.option.attribute.lightHeight + "px"
          : props.option.attribute.height + "px",
        width: item.isLight
          ? props.option.attribute.lightWidth + "px"
          : props.option.attribute.width + "px",
        url: item.url ? item.url : props.option.attribute.url ? fileUrl + props.option.attribute.url : '',
        draggable: false,
        point,
        opacity: 0.5,
        map: map.value,
        offsetY: 0,
        zIndex,
        properties: {
          title: "",
          size: "100",
        },
      });
      // 将自定义覆盖物添加到地图上
      map.value.addOverlay(customOverlay);
      if (item.myObj) {
        markersObj[item.myObj.ID] = customOverlay;
      }
      let label = new BMapGL.Label(item.name, {
        position: point,
        offset: new BMapGL.Size(labelOffsetY || 10, labelOffsetX || -10),
      });
      if (props.option.attribute.showname) {
        label.setStyle({
          backgroundColor: item.isLight
            ? props.option.attribute.LightLabelBgColor
            : labelBgColor || "#fff", // 背景色，这里使用了半透明的白色
          borderColor: item.isLight
            ? props.option.attribute.LightLabelBorderColor
            : labelBorderColor || "transparent", // 边框颜色，红色
          color: item.isLight
            ? props.option.attribute.lightTextColor
            : textColor || "#000000", // 文本颜色，这里设置为蓝色
          fontSize: item.isLight
            ? props.option.attribute.LightTextSize + "px"
            : textSize + "px" || "12px", // 文本字号
        });
      } else {
        label.setStyle({
          display: "none",
        });
      }
      label.setZIndex(zIndex);
      map.value.addOverlay(label);
      customOverlay.addEventListener("click", function (e) {
        // let data = { LNG: label.point.lng, LAT: label.point.lat, NAME: label.content }

        calcXY(e, item.myObj);
        console.log(props.option, "infoBoxOpeninfoBoxOpen3");
        infoBoxOpen(e, item.myObj);
      });
    } else if (props.option.cptDataForm.dataSource == "4") {
      console.log(item,'qwijdi0qwdi0qwdi0');
      // item.url = ''
      let point = new BMapGL.Point(item.lng, item.lat);
      if (item.url == undefined || item.url == "") {
        let zIndex = item.isLight ? 200 : 100;
        // 创建自定义覆盖物DOM
        // const customOverlay = createCustomOverlay({
        //   tag: "img",
        //   height: item.isLight
        //     ? props.option.attribute.lightHeight + "px"
        //     : props.option.attribute.height + "px",
        //   width: item.isLight
        //     ? props.option.attribute.lightWidth + "px"
        //     : props.option.attribute.width + "px",
        //   url: item.url ? item.url : props.option.attribute.url ? fileUrl  + props.option.attribute.url :'',
        //   draggable: false,
        //   point,
        //   opacity: 0.5,
        //   map: map.value,
        //   offsetY: 0,
        //   zIndex,
        //   properties: {
        //     title: "",
        //     size: "100",
        //   },
        // });
        // // 将自定义覆盖物添加到地图上

        // map.value.addOverlay(customOverlay);
        // markersObj[item.myObj.ID] = customOverlay;
        let { rowDataList } = props.option.attribute

        let ifData = rowDataList && rowDataList?.map((rowItem, rowIndex) => {
          let ifString = rowItem.searchFieldArr.reduce((prev, next, index) => {
            // 逻辑
            let logic = next.logic && (rowItem.searchFieldArr.length - 1 != index) ? next.logic : ''
            // 数据集字段值
            let dataField = item.myObj[next.fieldName] ? item.myObj[next.fieldName] : false

            let ifStrItem;
            // 聚合条件判断
            if (item.children && item.children?.length > 0) {
              ifStrItem = `item.children.every(c => ${prev}c.myObj["${next.fieldName}"]${next.operator}"${getTargetFieldVal(next, item)}"${logic})`

            } else {
              ifStrItem = `${prev}"${dataField}"${next.operator}"${getTargetFieldVal(next, item)}"${logic}`
            }

            return ifStrItem
          }, '')
          console.log(ifString, eval(ifString), item.children, 'ifStrItemifStrItemifStrItem');
          let ifData = ifString && eval(ifString)



          return ifData ? rowItem : false
        }).filter(f => f)
        let rowItemStyle = ifData && ifData?.length ? ifData[0].updateFieldArr[0] : false

        console.log(ifData, rowItemStyle, item.children, 'qdijwqidqwdjidij萨达阿斯阿斯');


        let iconUrl = null
        let iconWidth = item.isLight ? props.option.attribute.lightWidth : props.option.attribute.width
        let iconHeight = item.isLight ? props.option.attribute.lightHeight : props.option.attribute.height
        // 聚合
        console.log('asijdias isaidj saijd阿萨德及司机代售点加上低价阿萨德加速度加上')
        if ((item.children && props.option.attribute.pointClustererImage && item.children?.length)) {
          // 条件判断设置样式
          if (rowItemStyle) {
            iconUrl = fileUrl + rowItemStyle.clustererImage
            iconWidth = rowItemStyle.imageWidth
            iconHeight = rowItemStyle.imageHeight
          } else {
            iconUrl = fileUrl + props.option.attribute.pointClustererImage
          }
        } else {
          // 普通按钮
          iconUrl = item.url ? item.url : (fileUrl + props.option.attribute.url)
          // 条件判断设置样式
          if (rowItemStyle) {
            iconUrl = fileUrl + rowItemStyle.iconImage
            iconWidth = rowItemStyle.imageWidth
            iconHeight = rowItemStyle.imageHeight
          }
        }


        // 图标start-------------------------------------------------

        let ifIconUrl = iconUrl
        if(isChangePonit.value) {
          // 
          switch (item.myObj['TYPE']) {
            case 1:
              ifIconUrl = '/file/imgPool/202408/5a422edd1c514f3eb6177b952e89c46b.png'
              break;
              case 2:
              ifIconUrl = '/file/imgPool/202408/c07fac4a2fa4474b8553a732f12a3b0a.png'
              break;
              case 3:
              ifIconUrl = '/file/imgPool/202408/8715b24d8d8d4545abbc7b9a8811f969.png'
              break;
          }
        } else {
          // 高亮选中图表
          ifIconUrl = item.isLight ? '/file/imgPool/202407/95c53070586f452eadd59dd968442c10.png' : iconUrl
        }

        console.log(ifIconUrl,'ifIconUrlifIconUrlifIconUrlifIconUrl')

        // 设置图标样式
        let myIcon = ''
        // 高亮
        if(item.isLight) {
          myIcon = new BMapGL.Icon(
            '/file/imgPool/202407/95c53070586f452eadd59dd968442c10.png',
            new BMapGL.Size(
              iconWidth || 20,
              iconHeight || 20,
            )
          );
        } else {
          myIcon = new BMapGL.Icon(
            ifIconUrl,
            new BMapGL.Size(
              isChangePonit.value ? 20 : iconWidth,
              isChangePonit.value ? 20 : iconHeight,
            )
          );
        }

        // 图标end-------------------------------------------------


        console.log(item,labelOffsetY,labelOffsetX, 'qowjdioqpdqwkdqwdqwkodqwkodqwkodqkodqdokq');
        let labelName = (item.children && props.option.attribute.pointClustererText && item.children?.length) ? `${props.option.attribute.pointClustererText}： ${item.children.length}` : item.name

        let labelOffsetChangePoint = [labelOffsetY || 10,labelOffsetX || -10]
        if(isChangePonit.value) {
          labelOffsetChangePoint = [-40,-40]
        }

        label.value = new BMapGL.Label(labelName, {
          position: point,
          offset: new BMapGL.Size(labelOffsetChangePoint[0], labelOffsetChangePoint[1]),
        });
        


        let backgroundColor = item.isLight ? props.option.attribute.LightLabelBgColor : labelBgColor || "#fff"
        let borderColor = item.isLight ? props.option.attribute.LightLabelBorderColor : labelBorderColor || "transparent"
        let color = item.isLight ? props.option.attribute.lightTextColor : textColor || "#000000"
        let fontSize = item.isLight ? props.option.attribute.LightTextSize + "px" : textSize + "px" 
        if (rowItemStyle) {
          backgroundColor = rowItemStyle.labelBgColor
          borderColor = rowItemStyle.labelBorderColor
          fontSize = rowItemStyle.fontSize + 'px'

        }

        let fontStyle = {
          width: props.option.attribute.labelWidth || isChangePonit.value ? props.option.attribute.labelWidth + 'px' : iconWidth + 'px',
          backgroundColor, // 背景色，这里使用了半透明的白色
          borderColor, // 边框颜色，红色
          color, // 文本颜色，这里设置为蓝色
          fontSize, // 文本字号
          textAlign: isChangePonit.value ? 'left' :'center',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',

        }
        
        if(item.hasOwnProperty('name1') || item.hasOwnProperty('name2') || item.hasOwnProperty('name3')) {
          fontStyle.width = iconWidth + 'px'
          console.log(fontStyle, 'qijdiqwjijidqjdi');
        }
        console.log(props.option.attribute.labelWidth, isChangePonit.value,'props.option.attribute.labelWidth && isChangePonit.value')
        
        console.log(fontStyle,'fontStyle');
        const mapLabel = label.value;
        if (props.option.attribute.showname) {
          // 设置标签样式
          // let backgroundColor = item.isLight ? props.option.attribute.LightLabelBgColor : labelBgColor || "#fff"
          // let borderColor = item.isLight ? props.option.attribute.LightLabelBorderColor : labelBorderColor || "transparent"
          // let color = item.isLight ? props.option.attribute.lightTextColor : textColor || "#000000"
          // let fontSize = item.isLight ? props.option.attribute.LightTextSize + "px" : textSize + "px" || "12px"
          // let labelWidth = props.option.attribute.labelWidth == 'unset' ? 'unset' : 

          // if (rowItemStyle) {
          //   backgroundColor = rowItemStyle.labelBgColor
          //   borderColor = rowItemStyle.labelBorderColor
          //   fontSize = rowItemStyle.fontSize
          // }

          // label.value.setStyle({
          //   backgroundColor, // 背景色，这里使用了半透明的白色
          //   borderColor, // 边框颜色，红色
          //   color, // 文本颜色，这里设置为蓝色
          //   fontSize, // 文本字号
          //   width: props.option.attribute.labelWidth + 'px',
          //   textAlign: 'center',
          //   whiteSpace: 'nowrap',
          //   overflow: 'hidden',
          //   textOverflow: 'ellipsis',
          //   maxWidth: '110px'


          // });
          label.value.setStyle(fontStyle)
        } else {
          label.value.setStyle({
            display: "none",
          });
        }








        label.value.setZIndex(zIndex);

        let marker = new BMapGL.Marker(point, { icon: myIcon }); // 创建标注
        marker.setLabel(label.value)



        if (props.option.attribute.polyLineLabel) {
          let startName = `${index + 1}`
          if (index == 0) {
            startName = '起'
          } else if (index == (cptData.value.length - 1)) {
            startName = '终'
          }
          // let labelWidth = label.value.domElement?.clientWidth
          let labelWidth = props.option.attribute.labelWidth ? props.option.attribute.labelWidth : iconWidth
          console.log(label.value, 'label.value');
          
          let labelgj = new BMapGL.Label(startName, {
            position: point,
            offset: new BMapGL.Size((labelOffsetX + labelWidth - 4) || 20, (labelOffsetY - 11) || -10),
          });
          labelgj.setZIndex(zIndex + 10);
          labelgj.setStyle({
            width: '15px',
            height: '15px',
            'line-height': '15px',
            'font-size': '12px',
            textAlign: 'center',
            borderRadius: '15px',
          })

          labelgj.setStyle({
            backgroundColor: props.option.attribute.polyLineLabelBgColor,
            borderColor: props.option.attribute.polyLineLabelBorderColor,
            color: props.option.attribute.polyLineLabelFontColor,
            fontSize: props.option.attribute.polyLineLabelFontSize,
            fontFamily: props.option.attribute.polyLineLabelFontFamily
          });

          map.value.addOverlay(labelgj);
        }

        let customHTML = ``
        let otherLabelOffsetX = 0
        let moreLabelStyle = {
          ...fontStyle,
          textAlign: 'center'
        }
        const styleString = Object.entries(moreLabelStyle)
          .map(([key, value]) => `${key.replace(/([A-Z])/g, '-\$1').toLowerCase()}:${value}`)
          .join('; ');
        for (const key in item) {
          let label = key.split('name').pop()
          console.log(key, label, 'qijwdqwijidqwi');
          
  

          if (label && !isNaN(label)) {
            otherLabelOffsetX += 1
            // let otherLabel = new BMapGL.Label(item[key], {
            //   // position: point,
            //   offset: new BMapGL.Size(labelOffsetY, labelOffsetX + (otherLabelOffsetX * 20)),
            // });

            // let backgroundColor = item.isLight ? props.option.attribute.LightLabelBgColor : labelBgColor || "#fff"
            // let borderColor = item.isLight ? props.option.attribute.LightLabelBorderColor : labelBorderColor || "transparent"
            // let color = item.isLight ? props.option.attribute.lightTextColor : textColor || "#000000"
            // let fontSize = item.isLight ? props.option.attribute.LightTextSize + "px" : textSize + "px" || "12px"
            // if (rowItemStyle) {
            //   backgroundColor = rowItemStyle.labelBgColor
            //   borderColor = rowItemStyle.labelBorderColor
            //   fontSize = rowItemStyle.fontSize

            // }


            // let style = {
            //   width: props.option.attribute.labelWidth + 'px',
            //   backgroundColor, // 背景色，这里使用了半透明的白色
            //   borderColor, // 边框颜色，红色
            //   color, // 文本颜色，这里设置为蓝色
            //   fontSize, // 文本字号
            //   textAlign: 'center',
            //   textAlign: 'center',
            //   whiteSpace: 'nowrap',
            //   overflow: 'hidden',
            //   textOverflow: 'ellipsis',
            //   maxWidth: '110px'
            // }

            // left: ${labelOffsetY}px;
            let defaultStyleTop = labelOffsetX + (otherLabelOffsetX * 20)
            let name1StyleTop = key == 'name1' ? labelOffsetX + (otherLabelOffsetX * 20) - 20 : defaultStyleTop

            let absolute = `

              position:absolute;
              left: 50%;
              transform: translateX(-50%);
              top: ${name1StyleTop}px;

              cursor: pointer;
              pointer-events: none;
              display: flex;
              align-items: center;
              justify-content: center;
            `
            console.log(key,item,'qwdi0j0qwdju89qwdj89qwdjh8u9qwdh8u9q-wduh9dhu9asdhuaca')
            let textColor = ''
            let textTitle = ''
            if(key == 'name1') {
              textColor = 'color:blue;'
              textTitle = '抄表率：'
            } else if(key == 'name2') {
              textColor = 'color:yellow;'
              textTitle = '总数：'
            } else if(key == 'name3') {
              textColor = 'color:rgb(32,60,103);'
              textTitle = '已抄：'
            }
            customHTML += `<div class="custom-label" style="${styleString};${absolute}">
                <span>${textTitle}</span>
                <p style="${textColor};">${item[key]}</p>
              </div>`

            // otherLabel.setStyle(fontStyle)

            // marker.setLabel(otherLabel)


          }
        }

        console.log(item,'qwijmdwqidqwdiqwiddiwq')

        let eventMarker = marker
        
        
        if (customHTML.length && !isChangePonit.value) {


          console.log(point, 'qwjdqodjwqoidqiodqdio');

          function createDiv() {
            let div = document.createElement('div')
            div.style.position = 'relative'
            div.style.cursor = 'pointer'
            div.style.pointerEvents = 'none'
            div.id = item.myObj['ID']

            let absolute = `
              position:absolute;
              left: ${labelOffsetY}px;
              top: ${labelOffsetX + 20}px;
              cursor: pointer;
              pointer-events: none;
            `

            div.innerHTML = `<div class="custom-label" style="${styleString};${absolute}">${item['name']}</div>` + customHTML


            let img = document.createElement('img')
            img.src = item.isLight ? '/file/imgPool/202407/95c53070586f452eadd59dd968442c10.png' : iconUrl
            img.width = iconWidth
            img.height = iconHeight
            div.appendChild(img)

            return div
          }
  
          const customOverlay = new BMapGL.CustomOverlay(createDiv, {
            point,
            opacity: 0.5,
            map: map.value,
            offsetY: 0,
            zIndex: 10000,
            properties: {
              title: "",
              size: "100",
            },
          });
          
          // console.log(,'qwduhqwuh9idwuqhhuwq  qwdqw q ')
          const hasElement = document.getElementById(item.myObj['ID'])
          if(!hasElement) {
            // 添加自定义canvas到地图上
            map.value.addOverlay(customOverlay);
            setTimeout(() => {
              let centerGps = item.myObj.GPS.split(',')
              let newPonit = new BMapGL.Point(centerGps[0],centerGps[1])
              map.value.setCenter(newPonit)
            },200)
            
            console.log(item, 'customOverlaycustomOverlaycustomOverlay');
          }

          customOverlay.addEventListener('click', e => {
            console.log('?????',item);
            emit(
              "clickHandler",
              props.option.interaction,
              {
                default: "default",
                event: e,
                current: props.current,
              },
              item.myObj,
              "cpt-realtime-position"
            );
          })
          eventMarker = customOverlay
        } else {
          map.value.addOverlay(marker); // 将标注添加到地图中
          eventMarker = marker
        }


        if (location.href.includes('30f77dcff63b64310436927ae97782a5')) {

          let closeTimer = null
          let hoverPopup = null

          // 事件绑定
          eventMarker.addEventListener('mouseover', function (e) {
            console.log(e.currentTarget.div);
            map.value.openInfoWindow(infoHoverPopup, marker.getPosition());
            hoverPopup = document.querySelector('.BMap_bubble_pop')


            hoverPopup.addEventListener('mouseover', function (e) {

              // map.value.disableScrollWheelZoom();
              clearTimeout(closeTimer);

              // map.value.openInfoWindow(infoHoverPopup, marker.getPosition());

            })
            hoverPopup.addEventListener('mouseout', function (e) {
              // map.value.enableScrollWheelZoom();
              console.log('close', e.currentTarget.div);
              map.value.closeInfoWindow();

            })

          });

          eventMarker.addEventListener('mouseout', function (e) {


            closeHoverPopup()
          });

          function closeHoverPopup() {
            closeTimer = setTimeout(() => {
              map.value.closeInfoWindow();
              map.value.enableScrollWheelZoom();
            }, 500); // 延迟关闭
          }

          // // 百度地图的鼠标事件，确保弹窗在鼠标移入标点或弹窗时不关闭
          // map.value.addEventListener('mouseover', clearCloseTimer);
          // map.value.addEventListener('mouseout', scheduleCloseInfoWindow);


          // function openInfoWindow() {
          //   map.value.openInfoWindow(infoHoverPopup, marker.getPosition());
          //   // clearCloseTimer();
          // }
          // function scheduleCloseInfoWindow() {
          //   closeTimer = setTimeout(() => {
          //     map.value.closeInfoWindow();
          //   }, 500); // 延迟关闭
          // }
          // function clearCloseTimer() {
          //   clearTimeout(closeTimer);
          // }

        }


        eventMarker.addEventListener("click", function (e) {
          loading.value = true
          if (props.option.attribute.pointClusterer && item?.children) {
            console.log(item?.children, 'qwdjioqdwqdqdqwdwq');

            let li = item.children.map(item => {
              console.log(item, 'item');
              return `<li class="clustererLi" >
                            <span>${item.myObj['NAME']}</span>                
                            <span><i>地址：</i>${item.myObj['YHDZ']}</span>
                            <span><i>${item.myObj['BT']}：</i ><u ${item.myObj['CJBZ'] == 'N' ? 'style="color:red;text-decoration: unset;"' : ''}>${item.myObj['ZT']}</u></span>
                          </li>`
            })
            console.log(li, 'lililililili');
            var html = `
                             <div class="custom-info-window-pointClusterer">
                              <ul>
                                ${li.join('')}
                              </ul>
                          </div>
                        `

            var infoWindow = new BMapGL.InfoWindow(html, {
              width: 100, // 信息窗口宽度
              height: 300, // 信息窗口高度
              title: `用户列表(${item?.children?.length || 0})` // 信息窗口标题
            });
            this.openInfoWindow(infoWindow)
            loading.value = false

            // map.value.disableScrollWheelZoom();


            // console.log(map.value, BMapGL.InfoWindow );

            // let hoverPopup = document.querySelector('.BMap_bubble_pop')

            // hoverPopup.addEventListener('mouseover', function (e) {
            //   map.value.disableScrollWheelZoom();

            //   // map.value.openInfoWindow(infoHoverPopup, marker.getPosition());

            // })
            // hoverPopup.addEventListener('mouseout', function (e) {
            //   map.value.enableScrollWheelZoom();
            //   map.value.closeInfoWindow();

            // })

            setTimeout(() => {
              console.log(document.querySelectorAll('.clustererLi'));

              let lis = Array.from(document.querySelectorAll('.clustererLi'))

              for (let i = 0; i < lis.length; i++) {
                lis[i].addEventListener('click', function (e) {
                  emit(
                    "clickHandler",
                    props.option.interaction,
                    {
                      default: "default",
                      event: e,
                      current: props.current,
                    },
                    item.children[i].myObj,
                    "cpt-realtime-position"
                  );
                })

              }

            }, 100)


            return
          }
          loading.value = false



          map.value.centerAndZoom(new BMapGL.Point(item.lng, item.lat), props.option.attribute.zoom); // 初始化地图,设置中心点坐标和地图级别
          console.log(e, item.myObj, item, 'qwdi0wqi9djqidjidqwid0jq');
          setTimeout(() => {
            calcXY(e, item.myObj);
            console.log(props.option, "infoBoxOpeninfoBoxOpen");
            infoBoxOpen(e, item.myObj);
          }, 800)
        });







      } else {
        let zIndex = item.isLight ? 200 : 100;
        // 创建自定义覆盖物DOM
        marker.value = createCustomOverlay({
          tag: "img",
          height: item.isLight
            ? props.option.attribute.lightHeight + "px"
            : props.option.attribute.height + "px",
          width: item.isLight
            ? props.option.attribute.lightWidth + "px"
            : props.option.attribute.width + "px",
          url: item.url ? item.url : props.option.attribute.url ? fileUrl + props.option.attribute.url : '',
          draggable: false,
          point,
          opacity: 0.5,
          map: map.value,
          offsetY: 0,
          zIndex,
          properties: {
            title: "",
            size: "100",
          },
        });
        // 将自定义覆盖物添加到地图上
        map.value.addOverlay(marker.value);

        markersObj[item.myObj.ID] = marker.value;
        label.value = new BMapGL.Label(item.name, {
          position: point,
          offset: new BMapGL.Size(labelOffsetY || 10, labelOffsetX || -10),
        });
        if (props.option.attribute.showname) {
          label.value.setStyle({
            backgroundColor: labelBgColor || "#fff", // 背景色，这里使用了半透明的白色
            borderColor: labelBorderColor || "transparent", // 边框颜色，红色
            color: textColor || "#000000", // 文本颜色，这里设置为蓝色
            fontSize: textSize + "px" || "12px", // 文本字号
          });
        } else {
          label.value.setStyle({
            display: "none",
            backgroundColor: "rgba(255, 255, 255, 0.8)", // 背景色，这里使用了半透明的白色
            color: textColor || "#000000", // 文本颜色，这里设置为蓝色
            fontSize: textSize + "px" || "12px", // 文本字号
          });
        }
        marker.value.data = item;
        stateM.arrMarker.push(marker.value);
        label.value.setZIndex(zIndex);
        map.value.addOverlay(label.value);

        marker.value.addEventListener("click", function (e) {
          // let data = { LNG: label.point.lng, LAT: label.point.lat, NAME: label.content }
          calcXY(e, item.myObj);
          console.log(props.option, "infoBoxOpeninfoBoxOpen1");
          let eve = props.option.interaction.eventList.find(
            (x) => x.intName == "弹窗"
          );
          if (eve) {
            return;
          } else {
            infoBoxOpen(e, item.myObj);
          }
        });
      }
    }
  });


  // 鼠标移入时弹窗
  function initHoverPopup(item) {
    console.log(item, 'itemitemitemitem');
    let data = item && item?.myObj || {}
    var html = `
    <div class="custom-info-window-pointClusterer" id="hover-popup">
      <ul>
        <li class="clustererLi" >
          <span>表册名称：<p>${data['名称'] || ''}</p></span>                
        </li>
        <li class="clustererLi" >
          <span>抄表员：<p>${data['抄表员名称'] || ''}</p></span>                
        </li>
         <li class="clustererLi" >
          <span>总表数：<p>${data['总表数'] || 0}</p></span>                
        </li>
         <li class="clustererLi" >
          <span>已抄表：<p>${data['已抄表'] || 0}</p></span>                
        </li>
         <li class="clustererLi" >
          <span>未抄表：<p>${data['未抄表'] || 0}</p></span>                
        </li>
         <li class="clustererLi" >
          <span>正常抄表：<p>${data['正常抄表'] || 0}</p></span>                
        </li>
         <li class="clustererLi" >
          <span>异常抄表：<p>${data['异常抄表'] || 0}</p></span>                
        </li>
         <li class="clustererLi" >
          <span>绑定NFC数量：<p>${data['绑定NFC数量'] || 0}</p></span>                
        </li>
         <li class="clustererLi" >
          <span>未绑定NFC数量：<p>${data['未绑定NFC数量'] || 0}</p></span>                
        </li>
         <li class="clustererLi" >
          <span>采集GPS数量：<p>${data['采集GPS数量'] || 0}</p></span>                
        </li>
         <li class="clustererLi" >
          <span>未采集GPS数量：<p>${data['未采集GPS数量'] || 0}</p></span>                
        </li>
         <li class="clustererLi" >
          <span>图片已采集数量：<p>${data['图片已采集数量'] || 0}</p></span>                
        </li>
          <li class="clustererLi" >
          <span>抄表到位数：<p>${data['抄表到位数'] || 0}</p></span>                
        </li>
          <li class="clustererLi" >
          <span>抄表未到位数：<p>${data['抄表未到位数'] || 0}</p></span>                
        </li>
          <li class="clustererLi" >
          <span>抄表率：<p>${data['抄表率'] || '0%'}</p></span>                
        </li>
          <li class="clustererLi" >
          <span>GPS采集率：<p>${data['GPS采集率'] || '0%'}</p></span>                
        </li>
          <li class="clustererLi" >
          <span>图片采集率：<p>${data['图片采集率'] || '0%'}</p></span>                
        </li>
                                
      </ul>
  </div>
`

    var infoWindow = new BMapGL.InfoWindow(html, {
      width: 100, // 信息窗口宽度
      height: 300, // 信息窗口高度
      title: `数据明细`, // 信息窗口标题
      offset: new BMapGL.Size(-10, -30),
    });

    // map.value.addEventListener('mousemove', function (e) {
    //   console.dir(e.target, 'qwidjwqjiwqdji');
    //   if (e.target.className == "custom-info-window-pointClusterer") {
    //     e.target.addEventListener('wheel', function (event) {
    //       console.log(event, 'qwdi9qwu9qwjhu9dqwudhnwqd');
    //       // event.preventDefault()
    //       map.value.disableScrollWheelZoom();

    //       // event.stopPropagation()
    //     }, { passive: false })
    //   }
    // })



    return infoWindow
  }


  //获取info弹窗列表
  if (props.option.attribute.isQueryDetail) {
    getInfoData();
  }




    // 不知道processData在哪儿被重新调用了一次 导致一下代码全部会被执行两次, 事件注册也会执行两次 
  // -------------以下代码阻止加载时被瞬间执行两次------------
  // if(!isPageReload.value) {
  //   setTimeout(() => {
  //     isPageReload.value = true
  //   },1000)
  //   return 
  // // -------------以下代码阻止加载时被瞬间执行两次------------
  // } else {

    // isPageReload.value = false
  
    let polyLinePoint = null
    // 添加轨迹线
    if (props.option.attribute.polyLine) {
      // let config = {
      //   url: ifData ? fileUrl + rowItemStyle?.polylineImage : require('@/assets/map/guiji-jt.png'),
      //   imageWidth: ifData ? rowItemStyle?.imageWidth : props.option.attribute.polyLineImageWidth,
      //   imageHeight: ifData ? rowItemStyle?.imageHeight : props.option.attribute.polyLineImageHeight
      // }
      if (polyType.value == '1') {
        // config = Object.assign(config, {
        //   url: ifData ? rowItemStyle?.clustererImage : false
        // })
        // console.log(config, rowItemStyle, 'configconfigconfig');
        polyLinePoint = addPolyLine()
        actionLoading.value = false
        // 绑定轨迹线
        bindPolylineAnimation(polyLinePoint)
  
  
      } else {
        addWalkPolyline()
      }
    }
  // }





  map.value.addEventListener('mousemove', function (e) {
    let popupDiv = document.querySelector('.BMap_bubble_pop')
    if (!popupDiv) {
      map.value.enableScrollWheelZoom();
    }

    if (popupDiv) {
      let isShow = popupDiv.style?.display
      map.value.disableScrollWheelZoom();
      if (isShow === 'none') map.value.enableScrollWheelZoom();
    }
  })


};



function getTargetFieldVal(item, itemData) {
  console.log(item, 'qwdijqwidoqdjiqwjiod');
  if (item.fieldType == '固定值') {
    return item.fieldVal
  } else if (item.fieldType == 'url') {
    let params = getUrlParams()
    return params[item.fieldVal]
  } else if (item.fieldType == '数据集') {
    return itemData.myObj[item.fieldVal]
  }
}

function getUrlParams() {
  // 获取地址栏参数字符串（不含问号）
  const queryString = window.location.search.slice(1);

  // 将地址栏参数字符串解析为对象
  const params = {};
  queryString.split('&').forEach(param => {
    const [key, value] = param.split('=');
    if (key && value) {
      params[decodeURIComponent(key)] = decodeURIComponent(value.replace(/\+/g, ' '));
    }
  });

  console.log(`获取地址栏参数：${params}`); // 输出转换后的参数对象
  return params
}


function clickisChangePonit() {
  // map.value.clearOverlays()
  // let element = document.getElementById('#cus_overlay')
  // element.parentNode.removeChild(element)
  // isChangePonit.value = !isChangePonit.value
  // setTimeout(() => {
  //   initMap()
  // },2000)
  let allOverlayList = map.value.getOverlays()
  for (let i = 0; i < allOverlayList.length; i++) {
    map.value.removeOverlay(allOverlayList[i])
    
  }
  console.log('qwdwqdqdwqdwq',map.value,isChangePonit.value)
  isChangePonit.value = !isChangePonit.value
  let timeout = setTimeout(() => {
    initMap()
    clearTimeout(timeout)
  },1000)

}



const initMapForDrillDown = () => {
  console.log('执行他initMapForDrillDown');
  if (cptData.value.length == 0) {
    map.value.clearOverlays();
    return;
  }
  const {
    lightHeight,
    height,
    lightWidth,
    width,
    url,
    LightLabelBgColor,
    LightLabelBorderColor,
    lightTextColor,
    LightTextSize,
    labelBgColor,
    labelBorderColor,
    labelOffsetX,
    labelOffsetY,
    textColor,
    textSize,
    drillDownUrl,
    drillDownWidth,
    drillDownHeight,
    drillDownTextColor,
    drillDownTextSize,
    drillDownLabelBgColor,
    drillDownLabelBorderColor,
    paramsId
  } = props.option.attribute;
  const { zoom, lightField, showname, isQueryDetail, mapClick, sonZoom, sonCptTableData, cptTableData, mapDataSearch } = props.option.attribute;
  const labelStr = cptTableData.find(item => item.namekey == 'name').value;
  let sonStr = ''
  let pStr = ''
  if (mapClick) {
    sonStr = sonCptTableData.find(item => item.namekey == 'sid').value;
    pStr = sonCptTableData.find(item => item.namekey == 'pid').value;
  }
  let centerxs = cptData.value[0];
  if (lightField) {
    let xpoint = cptData.value.find(
      (x) => x.myObj[props.option.attribute.lightField] == _this?.paras[paramsId]
    );
    if (xpoint) {
      xpoint.isLight = true;
      centerxs = xpoint;
    }
  }
  console.log(cptData, "cptDatacptData65t54");
  map.value.centerAndZoom(new BMapGL.Point(centerxs.lng, centerxs.lat), zoom); // 初始化地图,设置中心点坐标和地图级别

  map.value.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放

  map.value.addEventListener("tilesloaded", () => {
    // 这里边写加载完成之后的执行操作
    console.log("loadingloading");
    loading.value = false;
  });

  map.value.addEventListener("rightclick", (e) => {
    // 这里边写加载完成之后的执行操作
    e.clientY = e.clientPos.y;
    e.clientX = e.clientPos.x;
  });
  map.value.clearOverlays();
  stateM.arrMarker = [];
  infoWindows = [];
  console.log(cptData.value, "cptDatacptDataTG4");
  map.value.addEventListener("zoomend", function (e) {
    const currentMapZoom = e.target.zoomLevel;
    if (currentMapZoom < sonZoom && currentLevel.value == 2) {
      // 下钻
      currentLevel.value = 1;
      currentPid.value = '';
      let data = copyNewData.filter(item => !item[pStr]);
      processData(props.option.cptDataForm, data, jsFunFlag.value);
      return;

    } else {
      return;
    }
  });


  //渲染多个点及多个点对应的图标
  cptData.value.forEach((item, index) => {
    let isPLevel = currentLevel.value == 1;
    let point = new BMapGL.Point(item.lng, item.lat);
    let zIndex = item.isLight ? 200 : 100;
    // 创建自定义覆盖物DOM
    const customOverlay = createCustomOverlay({
      tag: "img",
      height: item.isLight
        ? lightHeight + "px"
        : isPLevel ? height + "px" : drillDownHeight + "px",
      width: item.isLight
        ? lightWidth + "px"
        : isPLevel ? width + "px" : drillDownWidth + "px",
      url: item.url ? item.url : (isPLevel && url) ? fileUrl + url : drillDownUrl ? fileUrl + drillDownUrl : '',
      draggable: false,
      point,
      opacity: 0.5,
      map: map.value,
      offsetY: 0,
      zIndex,
      properties: {
        title: "",
        size: "100",
      },
    });
    // 将自定义覆盖物添加到地图上
    map.value.addOverlay(customOverlay);
    if (item.myObj) {
      markersObj[item.myObj.ID] = customOverlay;
    }
    let label = new BMapGL.Label(item.name, {
      position: point,
      offset: new BMapGL.Size(labelOffsetY || 10, labelOffsetX || -10),
    });
    if (showname) {
      label.setStyle({
        backgroundColor: item.isLight
          ? LightLabelBgColor
          : isPLevel ? labelBgColor : drillDownLabelBgColor || "#fff", // 背景色，这里使用了半透明的白色
        borderColor: item.isLight
          ? LightLabelBorderColor
          : isPLevel ? labelBorderColor : drillDownLabelBorderColor || "red", // 边框颜色，红色
        color: item.isLight
          ? lightTextColor
          : isPLevel ? textColor : drillDownTextColor || "#000000", // 文本颜色，这里设置为蓝色
        fontSize: item.isLight
          ? LightTextSize + "px"
          : isPLevel ? textSize + "px" : drillDownTextSize + "px" || "12px", // 文本字号
      });
    } else {
      label.setStyle({
        display: "none",
      });
    }
    label.setZIndex(zIndex);
    map.value.addOverlay(label);

    if (props.option.cptDataForm.dataSource == "4") {
      if (item.url) {
        marker.value.data = item;
        stateM.arrMarker.push(marker.value);
        marker.value.addEventListener("click", function (e) {
          if (mapClick && currentLevel.value == 1) {
            currentLevel.value = 2;
            isPLevel = false;
            currentPid.value = item?.myObj[sonStr];
            let params = {};
            params[paramsId] = currentPid.value
            if (mapDataSearch) {
              refreshCptData(props.option.cptDataForm, params)
            } else {
              processData(props.option.cptDataForm, resSonData.filter(item => item[pStr] == currentPid.value), jsFunFlag.value);
            }
            return;
          }
          // let data = { LNG: label.point.lng, LAT: label.point.lat, NAME: label.content }
          calcXY(e, item.myObj);
          console.log(props.option, "infoBoxOpeninfoBoxOpen1");
          let eve = props.option.interaction.eventList.find(
            (x) => x.intName == "弹窗"
          );
          if (eve) {
            return;
          } else {
            infoBoxOpen(e, item.myObj);
          }
        });
      } else {
        customOverlay.addEventListener("click", function (e) {
          if (mapClick && currentLevel.value == 1) {
            currentPid.value = item?.myObj[sonStr];
            currentLevel.value = 2;
            isPLevel = false;
            let params = {};
            params[paramsId] = currentPid.value
            if (mapDataSearch) {
              refreshCptData(props.option.cptDataForm, params)
            } else {
              processData(props.option.cptDataForm, resSonData.filter(item => item[pStr] == currentPid.value), jsFunFlag.value);
            }
            return;
          }
          // let data = { LNG: label.point.lng, LAT: label.point.lat, NAME: label.content }
          calcXY(e, item.myObj);
          console.log(props.option, "infoBoxOpeninfoBoxOpen3");
          infoBoxOpen(e, item.myObj);
        });
      }
    }
  });

  // console.log(new BMapGL, 'new BMapGL');


  //获取info弹窗列表
  if (isQueryDetail) {
    getInfoData();
  }
};

/**---------------------------------- 步行规划 init --------------------------------- */

function addWalkPolyline() {
  actionLoading.value = true
  let ponitList = JSON.parse(JSON.stringify(cptData.value))


  let waypoints = ponitList.map(item => new BMapGL.Point(item.lng, item.lat))
  let walkLength = 0
  let walkTotalList = []
  let walkStep = 0
  console.log('数据重新渲染');
  // 当数据为1时 弹窗关闭
  if(ponitList.length <= 1) {
    actionLoading.value = false
  }
  // WalkingRoute
  var walk = new BMapGL.WalkingRoute(map.value, {
    renderOptions: { map: map.value, panel: "results" },

    onSearchComplete: function (results) {
      console.log(results, 'resultsresultsresultsresultsresults');
      // let pts = results?.getPlan(0).getRoute(0).getPath()
      if (!results || String(results) == '{}') {
        return false
      }
      let pts = results?._plans && results?._plans[0]?._routes[0]?._points
      if (!pts) {
        return false
      }
      walkTotalList.push(...pts)

      let obj = {
        sequence: true,
        strokeTexture: {},
        strokeWeight: (props.option.attribute.polyLineStrokeWeight || 10),
        strokeOpacity: 1,
        strokeColor: props.option.attribute.polyLineColor
      }
      if (props.option.attribute.polyLineStyle == 'image') {

        obj['strokeTexture'] = {
          url: require('@/assets/map/guiji-jt.png'),
          width: props.option.attribute.polyLineImageWidth,	// 图片的宽度 
          height: props.option.attribute.polyLineImageHeight,	// 图片的宽度
        }
      }
      let polyline = new BMapGL.Polyline(pts, obj)
      map.value.addOverlay(polyline)
      let icon = new BMapGL.Icon(require('@/assets/map/avatar15.png'), new BMapGL.Size(40, 40), { anchor: new BMapGL.Size(24, 24) })
      lushu.value = new BMapGLLib.LuShu(map.value, walkTotalList, {
        defaultContent: '轨迹', // "信息窗口文案"
        autoView: true, // 是否开启自动视野调整，如果开启那么路书在运动过程中会根据视野自动调整
        speed: 100,
        // icon: new BMapGL.Icon('./images/car.png', new  BMapGL.Size(32, 32), { anchor: new BMapGL.Size(10, 10) }),
        icon,
        enableRotation: true, // 是否设置marker随着道路的走向进行旋转
      });
      console.log(walkTotalList.length, walkTotalList, 'qwdoipjwqojidqiopjdqwiidjqjiqwdiwjqdiqjd');

      walkStep += 1
      walk.search(waypoints[walkStep], waypoints[walkStep + 1])

      console.log(walkStep,ponitList,'qwjidqidjiqd');

      console.log('渲染点完成');
      if(walkStep == ponitList.length - 1) {
        actionLoading.value = false
      }

    },
    onMarkersSet: function (routes) {
      map.value.removeOverlay(routes[0].marker)
      map.value.removeOverlay(routes[routes.length - 1].marker)

    },
    onPolylinesSet: function (result) {
      walkLength += 1
      console.log(walkLength, waypoints,walkStep, 'qdjiqi9jwdiqwjdiqwjidi');
      // if(walkStep == ponitList.length - 1) {
      //   console.log('渲染完成!!!!!');
      // }
      // if ((walkLength + 1) == (waypoints.length - 2)) {
      if(walkLength == walkStep) {
        // actionLoading.value = false
        let lushuButton = document.querySelector('#lushu-shoudong')
        console.log(lushuButton, 'lushuButtonlushuButtonlushuButton');
        if (lushuButton) {
          // lushuButton.addEventListener('click', bindLushuClick)
          lushuButton.onclick = bindLushuClick
        
        }


        // setTimeout(() => {
        //   let icon = new BMapGL.Icon(require('@/assets/map/avatar15.png'), new BMapGL.Size(40, 40), { anchor: new BMapGL.Size(24, 24) })
        //   let marker = new BMapGL.Marker(walkTotalList[0], { icon: icon }); // 创建标注
        //   console.log(marker,walkTotalList, 'qwdijkoqijdqdijowqiojdqioj');
        //   map.value.addOverlay(marker);

        //   moveMarker(0, walkTotalList, marker, 400)
        //   // let i = 0
        //   // let intervalTime = setInterval(() => {
        //   //   i += 1
        //   //   if (i == walkTotalList.length) {
        //   //     clearInterval(intervalTime)
        //   //     return
        //   //   }
        //   //   marker.setPosition(walkTotalList[i]);

        //   // }, 200)
        // }, 5000)

      }


    }
  });
  // console.log(waypoints, 'waypointswaypointswaypoints');
  // for (let i = 0; i < waypoints.length; i++) {
  //   console.log(i, i + 1, '????');
  // }

actionLoading.value = false

  walk.search(waypoints[0], waypoints[1])



}

function moveMarker(step, walkTotalList, marker, duration) {
  if (step >= walkTotalList.length) {
    return
  }
  smoothMoveMarker(marker, { lat: walkTotalList[step].lat, lng: walkTotalList[step].lng }, walkTotalList[step + 1], duration, () => {
    moveMarker(step + 1, walkTotalList, marker)
  })
}
function smoothMoveMarker(marker, startPoint, endPoint, duration = 1000, callback) {
  var startLat = startPoint.lat;
  var startLng = startPoint.lng;
  var endLat = endPoint.lat;
  var endLng = endPoint.lng;
  var startTime = new Date().getTime();

  function animate() {
    var currentTime = new Date().getTime();
    var elapsed = currentTime - startTime;
    var progress = Math.min(elapsed / duration, 1);

    var lat = startLat + (endLat - startLat) * progress;
    var lng = startLng + (endLng - startLng) * progress;
    marker.setPosition(new BMapGL.Point(lng, lat));

    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {
      // 可选：平滑移动完成后中心视图移动到新的位置
      // map.value.centerAndZoom(new BMapGL.Point(endLng, endLat), 2);
      // callback
      callback && callback()
    }
  }

  animate();
}




/**---------------------------------- 步行规划 end --------------------------------- */


/**---------------------------------- 轨迹线 --------------------------------- */
function addPolyLine(config) {
  var point = [];
  for (var i = 0; i < cptData.value.length; i++) {
    point.push(new BMapGL.Point(cptData.value[i].lng, cptData.value[i].lat));
  }
  let obj = {
    sequence: true,
    strokeTexture: {},
    strokeWeight: (props.option.attribute.polyLineStrokeWeight || 10),
    strokeOpacity: 1,
    strokeColor: props.option.attribute.polyLineColor
  }
  if (props.option.attribute.polyLineStyle == 'image') {
    obj['strokeTexture'] = {
      // url: config.url,
      // width: config.imageWidth,	// 图片的宽度
      // height: config.imageHeight,	// 图片的宽度
      url: require('@/assets/map/guiji-jt.png'),
      width: props.option.attribute.polyLineImageWidth,
      height: props.option.attribute.polyLineImageHeight
    }
  }
  console.log(obj, point, 'qwdijqwidjqwidiqdqdwqdjqidwqji');
  var pl = new BMapGL.Polyline(point, obj);
  // map.value.addOverlay(pl);


  // // 动画参数
  // var duration = 1000; // 动画总时长（毫秒）
  // var interval = 10;   // 动画更新间隔（毫秒）
  // var steps = duration / interval; // 动画步数
  // var currentSegment = 0; // 当前段索引
  // var step = 0; // 当前步数

  // // 动画函数
  // function animateLine() {
  //   var progress = step / steps;
  //   var startPoint = point[currentSegment];
  //   var endPoint = point[currentSegment + 1];
  //   if (endPoint) {
  //     var newPoint = new BMapGL.Point(
  //       startPoint.lng + (endPoint.lng - startPoint.lng) * progress,
  //       startPoint.lat + (endPoint.lat - startPoint.lat) * progress
  //     );
  //     pl.setPath([...point.slice(0, currentSegment + 1), newPoint]);

  //     map.value.setCenter(newPoint)


  //     step++;
  //     if (step <= steps) {

  //       setTimeout(animateLine, interval);
  //     } else {
  //       console.log('qdiopjwqjidqwidjiqwdji111');
  //       // Move to the next segment
  //       step = 0;
  //       currentSegment++;
  //       if (currentSegment < point.length - 1) {
  //         // Continue with the next segment
  //         animateLine();
  //       }
  //     }
  //   }
  // }

  // // 启动动画
  // animateLine();


  return pl
}



function bindPolylineAnimation(point) {
  if(!point) {
    return 
  }
  console.log(point.points,'point.pointspoint.pointspoint.points')
  let poly = point.points?.map(item => {
    return new BMapGL.Point(item.latLng.lng,item.latLng.lat)
  }) || []
   // 创建一个 Polyline 实例
  //  polylineStart.value = new BMapGL.Polyline([], {
  //       strokeColor: "blue", // 线的颜色
  //       strokeWeight: 6, // 线的宽度
  //       strokeOpacity: 0.7 // 线的透明度
  //   });
  //   map.value.addOverlay(polylineStart.value); // 将线添加到地图上

    // 定义动画步骤
    var totalSteps = 100; // 每条线动画的总步数

    // 动画线段函数
    function animatePolyline(index) {
       
        if (index >= poly?.length - 1) {
            return; // 如果所有线都绘制完毕，停止
        }

        var start = poly[index];
        var end = poly[index + 1];
        var linePoints = [start]; // 动态线段的点数组
        var step = 0;

        // 创建线段
        polylineStart.value = new BMapGL.Polyline(linePoints, {
            strokeStyle: 'dashed',
            strokeColor: 'blue',
            strokeTexture: {
                url: require('@/assets/map/guiji-jt.png'),
                width: 16,
                height: 64
            },
            strokeWeight: 8,
            strokeOpacity: 0.8,
        });
        map.value.addOverlay(polylineStart.value); // 添加到地图

        function animate() {
          if(isPauseAnmination.value) {
            return
          }
            if (step <= totalSteps) {
                // 计算当前的插值点
                var lat = start.lat + (end.lat - start.lat) * (step / totalSteps);
                var lng = start.lng + (end.lng - start.lng) * (step / totalSteps);
                linePoints.push(new BMapGL.Point(lng, lat)); // 将当前点添加到线段中
                polylineStart.value.setPath(linePoints); // 更新线段的路径
                step++;
                requestAnimationFrame(animate); // 请求下一帧
            } else {
              pauseStepIndex.value++;
                // 动画完成后，继续绘制下一条线
                animatePolyline(index + 1); // 继续下一条线的动画
            }
        }

        animate(); // 开始当前线的动画
    }

    let polyLineButton = document.querySelector('#polyline-shoudong')
  if (polyLineButton) {
    console.log(polyLineButton,'polyLineButtonpolyLineButtonpolyLineButtonpolyLineButtonpolyLineButton')
     polyLineButton.onclick = () => {
       // 启动动画，从第一条线开始
       console.log('qwidh9qwiudjqidqwijdqiqwijdqidwqijqi')
       if(isPauseAnmination.value) {
        isPauseAnmination.value = false
         animatePolyline(pauseStepIndex.value);
         
       } else {
        isPauseAnmination.value = true
        
       }
    }
    // polyLineButton.addEventListener('click', () => {
    //    // 启动动画，从第一条线开始
    //    console.log('qwidh9qwiudjqidqwijdqiqwijdqidwqijqi')
    //    if(isPauseAnmination.value) {
    //     isPauseAnmination.value = false
    //      animatePolyline(pauseStepIndex.value);
    //    } else {
    //     isPauseAnmination.value = true
        
    //    }
    // })

  }

   

}

// // 动画线段函数
// function animatePolyline(gpsPoints) {
//     if (currentIndex >= gpsPoints.length - 1) {
//         return; // 所有线段绘制完毕
//     }

//     var start = gpsPoints[currentIndex];
//     var end = gpsPoints[currentIndex + 1];
//     var linePoints = [start]; // 动态线段的点数组

//     // 创建线段
//     polylineStart.value = new BMapGL.Polyline(linePoints, {
//         strokeColor: "red",
//         strokeWeight: 5,
//         strokeOpacity: 1
//     });
//     map.addOverlay(polylineStart.value); // 添加到地图

//     // 动画循环
//     function animate() {
//         if (!isAnimating) return; // 如果暂停，则退出

//         if (step <= totalSteps) {
//             // 计算当前的插值点
//             var lat = start.lat + (end.lat - start.lat) * (step / totalSteps);
//             var lng = start.lng + (end.lng - start.lng) * (step / totalSteps);
//             linePoints.push(new BMap.Point(lng, lat)); // 将当前点添加到线段中
//             polyline.setPath(linePoints); // 更新线段的路径
//             step++;
//             requestAnimationFrame(animate); // 请求下一帧
//         } else {
//             // 动画完成后，重置步数并继续绘制下一条线
//             currentIndex++;
//             step = 0; // 重置步数
//             animatePolyline(); // 继续绘制下一条线
//         }
//     }

//     animate(); // 开始当前线的动画
// }

// function bindPolylineAnimation123ddd(point) {
//   console.log(point,'asdokijodkqodopointpointpoint')
//   if (!point) {
//     return
//   }

//   // polylineStart.value = new BMapGL.Polyline(point.points  , {
//   //     strokeColor: "blue", // 线颜色
//   //     strokeWeight: 6, // 线宽
//   //     strokeOpacity: 0.5 // 线透明度
//   // });
//   // // 将轨迹添加到地图
//   // map.value.addOverlay(polylineStart.value);
//   // console.log(point,'pointpointpointpointpointpointpointpointpoint')


//   console.log(BMapGLLib, 'new BMapGLLib.TrackAnimation');
//   polylineStart.value = new BMapGLLib.TrackAnimation(map.value, point, {
//     overallView: true,
//     tilt: 0,
//     duration: props.option.attribute.polyLineLenTime || 20000,
//     delay: 100,
//     zoom: 17,

//   });
//   // console.log(polylineStart.value,'polylineStart.valuepolylineStart.valuepolylineStart.value')
//   // customOverlay.addEventListener("click", function (e) {
//   // })
//   let polyLineButton = document.querySelector('#polyline-shoudong')
//   console.log(polyLineButton, 'polyLineButtonpolyLineButton');
//   if (polyLineButton) {

//     polyLineButton.addEventListener('click', bindPolylineClick)

//   }




//   // if (props.option.attribute.polyLineAuto == 'auto') {

//   //   setTimeout(() => polylineStart.value.start(point), props.option.attribute.polyLineAutoTime);
//   // }
// }

// 触发轨迹事件
function bindPolylineClick() {

  console.log(polylineStart.value, 'polylineStart.value');
  if (polylineStart.value._status == 1) {
    polylineStart.value.pause()
  } else if (polylineStart.value._status == 3) {
    polylineStart.value.continue()
  } else if (polylineStart.value._status == 2) {
    polylineStart.value.start()
  } else {
    polylineStart.value.cancel()
  }



  // let time = 0
  // console.log(polylineStart.value,'polylineStart.value');
  // // 监听地图移动结束事件
  // map.value.addEventListener('moveend', function (e) {
  //   console.log(e);
  //   time++
  //   // console.log(map.value.getCenter(), e.currentTarget.fixCenter,e.currentTarget.centerPonit);
  //   console.log(time);
  //   map.value.setCenter(e.currentTarget.getCenterIn())
  //   if(time == 100) {
  //     // map.value.setCenter(e.currentTarget.fixCenter)
  //     console.log(e.currentTarget.getCameraPosition(),e.currentTarget.getCenterIn());
  //     time = 0
  //   }
  // });
}

function bindLushuClick() {

  if (lushuIsPlay.value) {
    lushu.value.start()
  } else {
    lushu.value.pause()
  }
}




/**---------------------------------- 聚合 --------------------------------- */

function setPointClusterer(value) {

  return clusterData(value)
}

// 根据经纬度计算球面距离，单位为米
function calculateDistance(point1, point2) {
  return getDistance(
    { latitude: point1.lat, longitude: point1.lng },
    { latitude: point2.lat, longitude: point2.lng }
  );
}

// 判断两个点是否在100米范围内
function withinRange(point1, point2) {
  return calculateDistance(point1, point2) <= (props.option.attribute.pointClustererRange || 10);
  // return false
}

// 函数来处理数据并返回归类结果
function clusterData(data) {
  // 存放每个群集的数组
  let clusters = [];

  // 遍历所有数据对象进行归类
  data.forEach(point => {
    // 是否已经归类到某个群集
    let addedToCluster = false;

    // 尝试将当前点归类到现有的群集中
    clusters.forEach(cluster => {
      if (!addedToCluster && withinRange(point, cluster[0])) {
        cluster.push(point);
        addedToCluster = true;
      }
    });

    // 如果没有找到可归类的群集，创建一个新的群集
    if (!addedToCluster) {
      clusters.push([point]);
    }
  });

  // 处理只有一个点的情况，直接返回该点的自身对象
  let result = clusters.map(cluster => {
    if (cluster.length === 1) {
      return cluster[0]; // 如果群集中只有一个点，直接返回该点自身对象
    } else {

      return {
        ...cluster[0],
        children: cluster
      }; // 否则返回包含 children 字段的对象
    }
  });

  console.log(result, ';resultresultresultresult');

  // 返回归类结果
  return result;
}

/**---------------------------------- 聚合end --------------------------------- */

/**---------------------------------- 切换轨迹方式 --------------------------------- */
function changePolyType(type) {
  console.log(type, polylineStart.value, polylineStart.value.cancel, 'typetypetype');
  if (lushu.value) lushu.value.stop()
  // if (polylineStart.value && polylineStart.value._status != 2) polylineStart.value.cancel()
  isPauseAnmination.value = true

  lushu.value = false
  polylineStart.value = false

  let lushuButton = document.querySelector('#lushu-shoudong')
  let polyLineButton = document.querySelector('#polyline-shoudong')
  if (lushuButton) {
    console.log(lushuButton, 'lushuButton');
    lushuButton.removeEventListener('click', bindLushuClick)
    // lushuButton.onclick = null
  }
  if (polyLineButton) {
    // 清空步数
    pauseStepIndex.value = 0


    // polyLineButton.onclick = null
    console.log(polyLineButton, 'polyLineButton');
    // polyLineButton.removeEventListener('click', bindPolylineClick)
  }

  initMap()

}


onMounted(async () => {
  // if (currentRoute != "design") {
  //   // var element_two = document.getElementById("container")
  //   // element_two.style.transform = 'scaleX(1.2) scaleY(1.2)';
  // }
  // await loadBaiduMap();



  console.log("asd333");
  map.value = new BMapGL.Map(props.current.id + "map"); // 创建Map实例

  // let canvas = Array.from(map.value.getContainer().children).find(item => {
  //   console.log(item,'qwdijqijidoqwi');
  // })
  // console.dir(canvas,'canvascanvascanvascanvas');
  // console.log(map.value.getContainer(),'map.valuemap.valuemap.valuemap.valuemap.value');
  // map.value.getContainer().style.backgroundColor = 'red !important'

  let type = props.option.attribute.mapType;
  console.log(type, 'typetypetype');
  if (type == "BMAP_NORMAL_MAP") {
    map.value.setMapType(BMAP_NORMAL_MAP);
  } else if (type == "BMAP_SATELLITE_MAP") {
    map.value.setMapType(BMAP_SATELLITE_MAP);
  } else if (type == "BMAP_HYBRID_MAP") {
    map.value.setMapType(BMAP_HYBRID_MAP);
  } else if (type == "BMAP_TERRAIN_MAP") {
    map.value.setMapType(BMAP_TERRAIN_MAP);
  } else if (type == "BMAP_EARTH_MAP") {
    map.value.setMapType(BMAP_EARTH_MAP);
  } else if (type == "lanse") {
    map.value.setMapStyleV2({
      styleId: "ea019bf0b01797cad5d04088f791ad91",
    });
  } else if (type == "xiuwen") {
    map.value.setMapStyleV2({
      styleId: "c74696059b15951abd921b357a3c363b",
      // styleId: "5e55ca220043f0e2d96f0a48002ce6a6",
      
      // styleId: '8d1b7749f8e5b1133cf33c2608ec1d5c',
    });
  } else {
    map.value.setMapType(BMAP_NORMAL_MAP);
  }




  currentLevel.value = 1;

  if (dataReload.value.includes(0)) {
    refreshCptData();
  }

});
//uuid 必须
let uuid = require("uuid").v1();
//自定义组件值接收字段
let cptData = ref([]);
let newData = reactive({});
let jsFunFlag = ref(false);

// 获取所有的点的info弹窗列表
const getInfoData = async () => {
  // 获取所有的点的info  _this.paras
  getResByDatasetIdApi(
    "a3e2acebb3a87ab669cfa5ebc7b837bc",
    "sql",
    _this.paras || {}
  ).then((res) => {
    if (res.code == 200) {
      console.log("getInfoData===", res);

      let resList = JSON.parse(res.data.apiRes);
      let resData = [];
      let nameArr = [];
      resList.forEach((item) => {
        if (!nameArr.includes(item.SBMC)) {
          nameArr.push(item.SBMC);
          let obj = { name: item.SBMC, list: [] };
          resData.push(obj);
        } else {
          let thisItem = resData.find((element) => element.name == item.SBMC);
          thisItem.list.push(item);
        }
      });

      console.log("resData===", resData);

      // resData = [
      //   {
      //     name: '滨江',
      //     list: [
      //       {"CJSJ":"07-12 16:17","JSSJ":"07-12 16:17","SBMC":"漫水河","DW":"Mpa","站点ID":5000152,"CHECKVALUE":0.273,"ZT":"正常","CJPL":"15","NAME":"进口压力"},
      //       {"CJSJ":"07-12 16:17","JSSJ":"07-12 16:17","SBMC":"漫水河","DW":"Mpa","站点ID":5000152,"CHECKVALUE":0.217,"ZT":"正常","CJPL":"15","NAME":"出口压力"},
      //       {"CJSJ":"07-12 16:17","JSSJ":"07-12 16:17","SBMC":"漫水河","DW":"V","站点ID":5000152,"CHECKVALUE":352.382,"ZT":"正常","CJPL":"15","NAME":"1#AB线电压"},
      //       {"CJSJ":"07-12 16:17","JSSJ":"07-12 16:17","SBMC":"漫水河","DW":"V","站点ID":5000152,"CHECKVALUE":323.255,"ZT":"正常","CJPL":"15","NAME":"1#BC线电压"},
      //       {"CJSJ":"07-12 16:17","JSSJ":"07-12 16:17","SBMC":"漫水河","DW":"V","站点ID":5000152,"CHECKVALUE":278.684,"ZT":"正常","CJPL":"15","NAME":"1#CA线电压"},
      //       {"CJSJ":"07-12 16:17","JSSJ":"07-12 16:17","SBMC":"漫水河","DW":"A","站点ID":5000152,"CHECKVALUE":0.077,"ZT":"正常","CJPL":"15","NAME":"1#A相电流"},
      //       {"CJSJ":"07-12 16:17","JSSJ":"07-12 16:17","SBMC":"漫水河","DW":"A","站点ID":5000152,"CHECKVALUE":0.449,"ZT":"正常","CJPL":"15","NAME":"1#B相电流"},
      //       {"CJSJ":"07-12 16:17","JSSJ":"07-12 16:17","SBMC":"漫水河","DW":"A","站点ID":5000152,"CHECKVALUE":0.906,"ZT":"正常","CJPL":"15","NAME":"1#C相电流"},
      //       {"CJSJ":"07-12 16:17","JSSJ":"07-12 16:17","SBMC":"漫水河","站点ID":5000152,"ZT":"正常","CJPL":"15","NAME":"1#总功率因数"},
      //       {"CJSJ":"07-12 16:17","JSSJ":"07-12 16:17","SBMC":"漫水河","DW":"kw","站点ID":5000152,"ZT":"正常","CJPL":"15","NAME":"1#正向有功电能"},
      //       {"CJSJ":"07-12 16:17","JSSJ":"07-12 16:17","SBMC":"漫水河","站点ID":5000152,"CHECKVALUE":1,"ZT":"正常","CJPL":"15","NAME":"1#泵机状态"},
      //     ]
      //   },
      //   {
      //     name: '漫水河',
      //     list: [
      //       {"CJSJ":"07-12 16:17","JSSJ":"07-12 16:17","SBMC":"漫水河","DW":"Mpa","站点ID":5000152,"CHECKVALUE":0.273,"ZT":"正常","CJPL":"15","NAME":"进口压力"},
      //       {"CJSJ":"07-12 16:17","JSSJ":"07-12 16:17","SBMC":"漫水河","DW":"Mpa","站点ID":5000152,"CHECKVALUE":0.217,"ZT":"正常","CJPL":"15","NAME":"出口压力"},
      //       {"CJSJ":"07-12 16:17","JSSJ":"07-12 16:17","SBMC":"漫水河","DW":"V","站点ID":5000152,"CHECKVALUE":352.382,"ZT":"正常","CJPL":"15","NAME":"1#AB线电压"},
      //       {"CJSJ":"07-12 16:17","JSSJ":"07-12 16:17","SBMC":"漫水河","DW":"V","站点ID":5000152,"CHECKVALUE":323.255,"ZT":"正常","CJPL":"15","NAME":"1#BC线电压"},
      //       {"CJSJ":"07-12 16:17","JSSJ":"07-12 16:17","SBMC":"漫水河","DW":"V","站点ID":5000152,"CHECKVALUE":278.684,"ZT":"正常","CJPL":"15","NAME":"1#CA线电压"},
      //       {"CJSJ":"07-12 16:17","JSSJ":"07-12 16:17","SBMC":"漫水河","DW":"A","站点ID":5000152,"CHECKVALUE":0.077,"ZT":"正常","CJPL":"15","NAME":"1#A相电流"},
      //       {"CJSJ":"07-12 16:17","JSSJ":"07-12 16:17","SBMC":"漫水河","DW":"A","站点ID":5000152,"CHECKVALUE":0.449,"ZT":"正常","CJPL":"15","NAME":"1#B相电流"},
      //       {"CJSJ":"07-12 16:17","JSSJ":"07-12 16:17","SBMC":"漫水河","DW":"A","站点ID":5000152,"CHECKVALUE":0.906,"ZT":"正常","CJPL":"15","NAME":"1#C相电流"},
      //       {"CJSJ":"07-12 16:17","JSSJ":"07-12 16:17","SBMC":"漫水河","站点ID":5000152,"ZT":"正常","CJPL":"15","NAME":"1#总功率因数"},
      //       {"CJSJ":"07-12 16:17","JSSJ":"07-12 16:17","SBMC":"漫水河","DW":"kw","站点ID":5000152,"ZT":"正常","CJPL":"15","NAME":"1#正向有功电能"},
      //       {"CJSJ":"07-12 16:17","JSSJ":"07-12 16:17","SBMC":"漫水河","站点ID":5000152,"CHECKVALUE":1,"ZT":"正常","CJPL":"15","NAME":"1#泵机状态"}
      //     ]
      //   },
      // ]

      let resDataObj = {};
      resData.forEach((item) => {
        resDataObj[item.name] = item;
      });

      stateM.arrMarker.forEach((item, index) => {
        if (!item.data) return;
        if (item.data && resDataObj[item.data.name]) {
          item.data.list = resDataObj[item.data.name].list || [];
        } else {
          item.data.list = [];
        }

        let infoContent = ` <div class="info-box">
            <div class="title">
              <span>${item.data.name}</span>
              <svg onclick="infoBoxClose(event, ${index})" t="1720700091156" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4259" width="24" height="24"><path d="M568 515.008l254.016-255.008q12-11.008 12-27.488t-11.488-28-28-11.488-27.488 12l-255.008 254.016-255.008-254.016q-11.008-12-27.488-12t-28 11.488-11.488 28 12 27.488l254.016 255.008-254.016 255.008q-12 11.008-12 27.488t11.488 28 28 11.488 27.488-12l255.008-255.008 255.008 255.008q11.008 12 27.488 12t28-11.488 11.488-28-12-27.488z" p-id="4260" fill="#ffffff"></path></svg>
            </div>
              <div class="info">
                `;
        item.data.list.forEach((item2) => {
          infoContent += `<div class="div-row"><span class="name">${item2.NAME
            }</span> <span class="value">${item2.CHECKVALUE || ""} <i>${item2.DW || ""
            }</i></span></div>`;
        });
        infoContent += `</div> </div>`;
        // let infoWindow = new BMapGL.InfoWindow(infoContent);
        // infoWindows.push(infoWindow);
        if (item.domElement) {
          item.domElement.innerHTML = infoContent;
        }
      });

      console.log("infoWindows====", infoWindows.length);
    }
  });
};

// 隐藏单个infoBox
window.infoBoxClose = function (event, index) {
  console.log("infoBoxClose");
  // console.log("event", event);
  console.log("index", index);
  const marker = stateM.arrMarker[Number(index)];
  marker.domElement.querySelector(".info-box").style.display = "none";
  event.preventDefault();
  event.stopPropagation();
};

// 显示单个infoBox
const infoBoxOpen = (e, myObj) => {
  console.log("infoBoxOpen");
  myObj.label = myObj.label || myObj.SITENAME;
  console.log(stateM.arrMarker, 'stateM.arrMarker');
  for (let index = 0; index < stateM.arrMarker.length; index++) {
    const marker = stateM.arrMarker[index];
    // const infoWindow = infoWindows[index];
    console.log(marker.data.name, myObj.label, marker.data.name == myObj.label, 'marker.data.name == myObj.label');
    if (marker.data.name == myObj.label) {
      // map.value.openInfoWindow(infoWindow, marker.getPosition());  //打开下一个会关闭前一个
      if(marker.domElement.querySelector(".info-box")) marker.domElement.querySelector(".info-box").style.display = "block";
      else console.log(marker.domElement.querySelector(".info-box"),'marker.domElement.querySelector(".info-box")')
    } else {
      if(marker.domElement.querySelector(".info-box")) marker.domElement.querySelector(".info-box").style.display = "none";
      else console.log(marker.domElement.querySelector(".info-box"),'marker.domElement.querySelector(".info-box")')

    }
  }
};

// 显示所有的infoBox
const infoBoxOpenAll = (boo) => {
  console.log("infoBoxOpenAll");
  for (let index = 0; index < stateM.arrMarker.length; index++) {
    const marker = stateM.arrMarker[index];
    // const infoWindow = infoWindows[index];
    // map.value.openInfoWindow(infoWindow, marker.getPosition());  //打开下一个会关闭前一个
    marker.domElement.querySelector(".info-box").style.display =
      boo == true ? "block" : "none";
  }
};

// setTimeout(()=>{
//    document.querySelector('#divebebc1a0-4012-11ef-82af-edff4a133292').onclick = function(){
//     if(refMap['ebebc1a0-4012-11ef-82af-edff4a133292'].cptData.value==true){
//       infoBoxOpenAll(true);
//     }else{
//       infoBoxOpenAll(false);
//     }
//    }
// },3000);

const calcXY = (e, data) => {
  var point = e.latLng;
  var pixel = map.value.pointToPixel(point); // 将地图坐标转换为像素坐标
  var pageX = pixel.x; // 像素坐标中的 x
  var pageY = pixel.y; // 像素坐标中的 y

  // 注意：pageX 和 pageY 是相对于地图容器的左上角的，不是相对于整个页面的
  // 如果需要相对于整个页面的坐标，需要加上地图容器的位置
  var container = document.getElementById("div" + props.current.id); // 假设你的地图容器id为'baidu-map-container'
  var containerRect = container.getBoundingClientRect();
  var offsetX = containerRect.left;
  var offsetY = containerRect.top;

  var pageXGlobal = pageX + offsetX;
  var pageYGlobal = pageY + window.scrollY + offsetY;
  e.pageX = pageXGlobal;
  e.pageY = pageYGlobal;
  emit(
    "clickHandler",
    props.option.interaction,
    {
      default: "default",
      event: e,
      current: props.current,
    },
    data,
    "cpt-realtime-position"
  );
};
//refreshCptData固定写法，必须！
const refreshCptData = (cptDataForm, paras, checkable) => {

  _this.paras = paras;

  console.log("paras====", paras);
  console.log("checkable====", checkable);
  if (checkable && paras.ID.split(",").length == 1) {
    //有勾选框，不需要请求，直接定位到勾选框；
    // console.log("cptData.value", cptData.value);
    let thisPoint = cptData.value.filter((item) => {
      return item.myObj.SITEID == paras.ID;
    })[0];
    console.log("thisPoint", thisPoint);
    if (thisPoint) {
      let thisMarker = markersObj[thisPoint.myObj.SITEID];
      console.log("thisMarker", thisMarker);
      let zoom = props.option.attribute.zoom + 5;
      map.value.centerAndZoom(
        new BMapGL.Point(thisPoint.lng, thisPoint.lat),
        zoom
      ); // 初始化地图,设置中心点坐标和地图级别
      try {
        calcXY(thisMarker, thisPoint.myObj);
      } catch (error) {
        console.log(error);
      }
      console.log('????aspojdaoisjdiodaijodiod');
    }
  } else {
    pollingRefresh(uuid, props.option.cptDataForm, () => {
      loadData(props.option.cptDataForm, paras);
    });
  }

  // pollingRefresh(uuid, props.option.cptDataForm, loadData)
};
//自定义数据处理方法
const loadData = (cptDataForm, paras) => {
  let param = JSON.parse(JSON.stringify(paras || []))
  if (currentLevel.value == 1 && param[props.option.attribute.paramsId]) {
    param = null;
  }
  getDataJson(
    props.option.cptDataForm,
    param,
    (res) => {
      //res为数据表单的静态数据或执行API返回的数据
      newData =
        props.option.cptDataForm.dataSource == "4" &&
          hasProperty(res, "jsFunction")
          ? res.resStr
          : res; //相同数据集只调用一次接口原因
      jsFunFlag.value =
        props.option.cptDataForm.dataSource == "4" &&
          hasProperty(res, "jsFunction")
          ? res.jsFunction
          : false; //相同数据集只调用一次接口原因
      const { mapDrillDown, sonCptTableData } = props.option.attribute
      if (mapDrillDown) {
        let pStr = sonCptTableData.find(item => item.namekey == 'pid').value;
        if (currentLevel.value == 1) {
          copyNewData = JSON.parse(JSON.stringify(newData));
          newData = copyNewData.filter(item => !item[pStr]);
          resSonData = copyNewData.filter(item => hasProperty(item, pStr));
        } else {
          newData = newData.filter(item => item[pStr] == currentPid.value);
        }
      }
      processData(props.option.cptDataForm, newData, jsFunFlag.value);
    },
    props.current
  );
};
const processData = (cptDataForm, res, jsFunFlag, isFromGrid) => {



  // 第一层判断 如果选择数据集
  if (cptDataForm.dataSource == "4") {
    let arr = JSON.parse(JSON.stringify(props.option.attribute.cptTableData));
    if (hasNonEmptyValues(arr)) {
      console.log(res, "cptDatacptData11");
      let newarr = transformArray(res, props.option.attribute.cptTableData);
      console.log(newarr, "newarr");
      // 开启聚合
      if (props.option.attribute.pointClusterer) {
        cptData.value = setPointClusterer(newarr);
      } else {
        cptData.value = newarr
      }

      console.log(cptData.value, 'cptData.value1111111');

      console.log(location.href,'jiqwdijqwidjwqidj')
      if(location.href.includes('7d03c2a7de748d99c6672474f63f5acd') || location.href.includes('fe779c3c2af94f7319e18523461334ae')) {
        // 修文标记点单独处理
        // 使用闭包来处理坐标数据
        let processCoordinates = createCoordinateProcessor(5, 0.0002);  // 5米内重叠点偏移0.00001度
        // 处理坐标并输出结果
        const processedData = processCoordinates(cptData.value);
        cptData.value = processedData
        console.log(processedData,'processedDataprocessedDataprocessedDataprocessedDataprocessedData');

      }

    }
  } else {
    // 不是数据集类型，是静态数据
    cptData.value = res;
  }
  console.log(cptData.value, "qwdqowkdwqopdoqkdoqwkpdokpqwdqowpkdw");

  // cptData.value = cptData.value.splice(0,10)
  // map.value = null;
  console.log(props.option.attribute.mapDrillDown, 'props.option.attribute.mapDrillDown')
  if (props.option.attribute.mapDrillDown) {
    initMapForDrillDown()
  } else {
    console.log('initMap int')
    initMap();
  }

};

function createCoordinateProcessor(offsetDistance = 5, offsetValue = 0.00001) {
    // Haversine公式：计算两个经纬度点之间的距离
    function haversine(lat1, lon1, lat2, lon2) {
        const R = 6371000; // 地球半径，单位：米
        const φ1 = lat1 * Math.PI / 180;
        const φ2 = lat2 * Math.PI / 180;
        const Δφ = (lat2 - lat1) * Math.PI / 180;
        const Δλ = (lon2 - lon1) * Math.PI / 180;

        const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
                  Math.cos(φ1) * Math.cos(φ2) *
                  Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return R * c; // 返回距离，单位：米
    }

    // 处理坐标，修改 lng, lat, myObj.jd, myObj.wd
    function processCoordinates(coords) {
        const result = [];
        
        coords.forEach((currentPoint) => {
            let isOffset = false; // 默认当前点没有偏移过

            // 遍历已经处理过的点，检查是否有重叠
            for (let i = 0; i < result.length; i++) {
                const existingPoint = result[i];
                const distance = haversine(currentPoint.lat, currentPoint.lng, existingPoint.lat, existingPoint.lng);

                if (distance < offsetDistance) { // 如果距离小于设定的偏移范围，说明重叠
                    isOffset = true;
                    break;
                }
            }

            if (isOffset) {
                // 如果已经偏移过了，标记该点，并且偏移指定的量
                const offsetPoint = {
                    ...currentPoint,
                    lng: (parseFloat(currentPoint.lng) + offsetValue).toFixed(6), // 向右偏移
                    lat: (parseFloat(currentPoint.lat) + offsetValue).toFixed(6), // 向上偏移
                    myObj: {
                        ...currentPoint.myObj,
                        jd: (parseFloat(currentPoint.myObj.jd) + offsetValue).toFixed(6), // 对应偏移 myObj.jd
                        wd: (parseFloat(currentPoint.myObj.wd) + offsetValue).toFixed(6)  // 对应偏移 myObj.wd
                    },
                    offset: true // 标记已经偏移
                };
                result.push(offsetPoint); // 将偏移过的点加入结果数组
            } else {
                // 否则直接加入，不偏移
                result.push({
                    ...currentPoint,
                    offset: false // 标记未偏移
                });
            }
        });

        return result; // 返回处理后的新数组
    }

    // 返回 processCoordinates 函数，外部可以使用它
    return processCoordinates;
}



const transformArray = (data, mapping) => {
  return data.map((item) => {
    let newItem = {};
    for (const map of mapping) {
      newItem[map.namekey] = item[map.value];
    }
    newItem.myObj = item;
    // 添加 'url' 字段，并设置为空字符串
    // newItem.url = "";
    return newItem;
  });
};
// const loadBaiduMap = async () => {
//   await loadBMap(' '); // 替换为实际的AK值
// }

// watch(props.option.attribute, () => {
//   // processData(props.option.cptDataForm, newData, jsFunFlag.value)
//   // initMap()
// }, {
//   deep: true
// })

//初始化数据，可选。echarts类组件需要放在onMounted中执行！
// refreshCptData()
//暴露refreshCptData，必须！
defineExpose({ refreshCptData, cptData, hideLabel, infoBoxOpenAll, stateM });
</script>
<style>
.loads .t-loading__overlay {
  background-color: var(---loadBg);
}


#container {
  border: var(---loadBorder);
}

.container {
  height: 100%;
  border: var(---loadBorder);
  border: 0;
  background-image: unset !important;
  outline: none;
}

.container /deep/ canvas {
  width: var(---width) !important;
  outline: none;
}

.container /deep/ .anchorBL {
  display: none;
}

/* #container{
background-color: var(---loadBg);
} */
</style>
<!-- <style scoped>
</style> -->

<style>
.bmap-container {
  background: unset !important;
}

/* .bmap-container canvas {
  opacity: 0;
} */

.hideCanvas canvas {
  opacity: 1;
  transition: opacity ease-in-out;
  transition-delay: 500ms;
}

.info-box {
  display: none;
  position: absolute;
  left: 30px;
  z-index: 99999999999999;
  font-size: 16px;
  color: #333;
  background: #fff;
  width: 250px;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 0 5px #cdcdcd;
}

.info-box .title {
  height: 30px;
  line-height: 30px;
  background: #51a7ac;
  color: #fff;
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info-box .title span {
  display: inline-block;
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info-box .info {
  padding: 10px;
  max-height: 220px;
  overflow: auto;
}

.info-box .div-row {
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info-box .name {
  display: inline-block;
  width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info-box .div-row i {
  font-size: 12px;
  font-style: normal;
}

/* 滚动条滑块 */
.info-box ::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  /* 滑块颜色 */
}

#polyline-shoudong,
#lushu-shoudong {
  position: absolute;
  top: 10px;
  right: 115px;
  background: #083c28;
  color: #fff;
  border: 1px solid #083c28;
  padding: 10px 20px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 500;
  /* font-family: 'YouSheBiaoTiHei-2'; */
  z-index: 1000;
  cursor: pointer;
}

.isChangePonit {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #083c28;
  color: #fff;
  border: 1px solid #083c28;
  padding: 10px 20px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 500;
  /* font-family: 'YouSheBiaoTiHei-2'; */
  z-index: 1000;
  cursor: pointer;
}

.custom-info-window-pointClusterer {
  height: calc(100% - 20px);
  box-sizing: border-box;
  overflow-y: scroll;
}

.custom-info-window-pointClusterer ul {
  display: flex;
  flex-wrap: wrap;
}

.custom-info-window-pointClusterer ul li {
  display: flex;
  flex-wrap: wrap;
  padding: 9px 10px;
  /* border-bottom: 1px solid #fff; */
  border-bottom: 1px solid rgba(72, 199, 156, 0.43);
  position: relative;
  cursor: pointer;
  flex-direction: column;
  width: 100%
}

.custom-info-window-pointClusterer ul li i {
  color: rgb(71, 157, 96);
  font-style: normal;
}

.custom-info-window-pointClusterer ul li:last-of-type {
  border-bottom: unset;
}


.custom-info-window-pointClusterer ul li::before {
  content: '';
  position: absolute;
  right: 3px;
  top: 50%;
  transform: translateY(-50%);
  background-image: url('@/assets/map/right-arrow.png');
  background-size: 100% 100%;
  width: 22px;
  height: 22px;
}

.custom-info-window-pointClusterer ul li span {
  font-size: 14px;
  color: #fff;
  font-weight: 500;
  line-height: 16px;
  display: inline-block;
  font-family: system-ui;
  padding-bottom: 7px;
}

.custom-info-window-pointClusterer ul li span:first-of-type {
  font-size: 14px;
  color: #fff;
  font-weight: 500;
  line-height: 18px;
  padding-bottom: 10px;
}

.BMap_bubble_content {
  width: 100% !important;
}

.BMap_bubble_title {
  font-size: 16px;
  color: #fff !important;
  text-align: center;
  margin-top: -4px;
}

.BMap_bubble_buttons>div>div {
  font-size: 24px !important;
  top: 0px !important;
}

.BMap_bubble_pop {
  background: transparent !important;
  border: 1px solid transparent !important;
  background-color: rgba(45, 47, 46, 1) !important;
}

.BMap_bubble_pop {
  background-image: url('@/assets/map/preview.png') !important;
  background-size: 100% 100% !important;
}

.BMap_bubble_pop>img {
  display: none !important;
}


.polytype {
  position: absolute;
  top: 10px;
  right: 5px;
  z-index: 1000;
  display: flex;
  align-items: center;
  color: #083c28;
  border-color: #083c28;
  background: #083c28;
}

.polytype .t-radio-group.t-radio-group__outline,
.polytype .t-radio-group.t-radio-group__outline .t-radio-button {
  height: 38px !important;
  border-color: transparent !important;
}

.t-radio-group .t-radio-button:hover {
  background: transparent !important;
}

.polytype .t-radio-group.t-radio-group__outline .t-radio-button:hover {
  color: rgba(104, 159, 35, 1);
}

.polytype .t-radio-group.t-radio-group__outline .t-radio-button.t-is-checked,
.polytype .t-radio-group .t-radio-button.t-is-checked {
  color: rgba(104, 159, 35, 1);
  /* background: #fff; */
  /* border-color: rgba(104, 159, 35, 1); */
  /* border-color: transparent; */
  /* box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    transform: translateY(-1px);
	-webkit-transition: all .1s;
	transition: all .1s; */

  /* background: url('https://xdwater365.com/file/imgPool/202407/8e3510186d5546baa550d0608089f284.png') no-repeat; */
  border: 2px solid;
  border-image: linear-gradient(45deg, rgb(32, 203, 103), transparent, transparent, transparent) 1;
  position: relative;

}
.polytype .t-radio-group.t-radio-group__outline .t-radio-button.t-is-checked::after,
.polytype .t-radio-group .t-radio-button.t-is-checked::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border: 2px solid;
  border-image: linear-gradient(220deg, rgb(32, 203, 103), transparent, transparent, transparent) 1;
}

#hover-popup ul,
#hover-popup ul li,
#hover-popup ul li span {
  pointer-events: none;
  /* 使子级元素穿透 */
}

#hover-popup .clustererLi span {
  display: flex;
  align-items: flex-start;
}

#hover-popup .clustererLi span p {
  flex: 1;
  text-align: right;
}

#hover-popup ul li span:first-of-type {
  padding-top: 0;
  padding-bottom: 0;
}

#hover-popup ul li::before {
  content: '';
  opacity: 0 !important;
  width: 0;
  height: 0;
}

.shadow img {
  width: 0 !important;
  height: 0 !important;
  z-index: -1 !important;
}
.shadow  {
  overflow: hidden;
  width: 0px !important;
  height: 0px !important;
}

.action-loading {
  position: absolute;
  top: 0;
  bottom: 0;
  left:0;
  right:0;
  background-color: rgb(33, 47, 63);
  width: 100%;
  height: 100%;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.action-loading span {
  color: #fff;
  margin-top: 12px;
  font-size: 14px;
}
</style>
